import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  deleteMakeRequest: ["withdrawal_id", "file_id"],
  deleteMakeSuccess: ["Status"],
  deleteMakeFailure: null,
});

export const DeleteMakeTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  withdrawal_id: null,
  fetching: null,
  success: null,
  error: null,
  Status: null,
  file_id: null,
});

export const DeleteMakeSelectors = {
  getData: (state: any) => state.deleteMake.data,
  isFetching: (state: any) => state.deleteMake.fetching,
  isSuccess: (state: any) => state.deleteMake.success,
  hasError: (state: any) => state.deleteMake.error,
};

export const request = (state: any, { withdrawal_id, file_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    withdrawal_id: withdrawal_id,
    file_id: file_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { Status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    Status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DELETE_MAKE_REQUEST]: request,
  [Types.DELETE_MAKE_SUCCESS]: success,
  [Types.DELETE_MAKE_FAILURE]: failure,
});
